import React from "react";
import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";
export default function CollectionOutstanding() {
  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const { RecOutstandingdata } = useSelector(
    (state) => state.ReceivablePaybleSlice,
  );

  function formatDateToDDMMYYYY(isoString) {
    if (!isoString) return "";

    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return ""; // Invalid date guard

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();

    return `${day}/${month}/${year}`;
  }

  const getRows = RecOutstandingdata?.Detail?.map((label, index) => ({
    // srNumber: index + 1,
    chart: true,
    AcName: label.AcName,
    VouDate: formatDateToDDMMYYYY(label.VouDate),
    Outstanding: label.Outstanding,
    Collection: label.Collection,
  }));

  const getColumns = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Ac Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Outstanding", key: "Outstanding", format: true, align: "right" },
    { label: "Paid", key: "Collection", format: true, align: "right" },
  ];

  if (RecOutstandingdata === "no" || RecOutstandingdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            COLLECTION OUTSTANDING
          </h2>
        </div>
        <FASTable data={getRows} columns={getColumns} />
      </div>
    </div>
  );
}
